<template>
  <div class="editPaperPage">
    <div class="btn-Group">
      <a-select
        v-model="pageData.typeid"
        style="width: 120px; margin-bottom:20px; margin-right:10px;"
      >
        <template v-for="questionType in listData.questionTypes">
          <a-select-option :key="questionType.id" :value="questionType.id">
            {{
            questionType.name
            }}
          </a-select-option>
        </template>
      </a-select>

      <a-select
        v-model="pageData.diff"
        style="width: 120px; margin-bottom:20px; margin-right:10px;"
      >
        <template v-for="diff in listData.diffData">
          <a-select-option :key="diff.id" :value="diff.id">
            {{
            diff.label
            }}
          </a-select-option>
        </template>
      </a-select>

      <a-select
        v-model="pageData.year"
        style="width: 120px; margin-bottom:20px; margin-right:10px;"
      >
        <template v-for="(year, indexYear) in listData.years">
          <a-select-option :key="indexYear" :value="year.value">
            {{
            year.name
            }}
          </a-select-option>
        </template>
      </a-select>
    </div>

    <a-card title="题文">
      <vue-ueditor-wrap v-model="pageData.stem" :config="config1" @ready="ready"></vue-ueditor-wrap>
    </a-card>

    <a-card title="答案">
      <vue-ueditor-wrap v-model="pageData.answer" :config="config2" @ready="ready"></vue-ueditor-wrap>
    </a-card>

    <a-card title="解析">
      <vue-ueditor-wrap v-model="pageData.explanation" :config="config3" @ready="ready"></vue-ueditor-wrap>
    </a-card>

    <a-card title="知识点">
      <div>
        <template v-for="(tag, index) in tags">
          <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
            <a-tag
              :key="tag"
              :closable="index !== 0"
              :afterClose="() => handleClose(tag)"
            >{{ `${tag.slice(0, 20)}...` }}</a-tag>
          </a-tooltip>
          <a-tag
            v-else
            :key="tag"
            :closable="index !== 0"
            :afterClose="() => handleClose(tag)"
          >{{ tag }}</a-tag>
        </template>
        <a-input
          v-if="inputVisible"
          ref="input"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          :value="inputValue"
          @change="handleInputChange"
          @blur="handleInputConfirm"
          @keyup.enter="handleInputConfirm"
        />
        <a-tag v-else @click="showInput" style="background: #fff; borderStyle: dashed;">
          <a-icon type="plus" />添加
        </a-tag>
      </div>
    </a-card>

    <a-card title="来源">
      <a-textarea v-model="pageData.source" placeholder="Basic usage" :rows="2" />
    </a-card>

    <a-card title="等级">
      <a-radio-group v-model="pageData.level">
        <template v-for="level in listData.levels">
          <a-radio :key="level.id" :value="Number(level.name)">
            {{
            level.label
            }}
          </a-radio>
        </template>
      </a-radio-group>
    </a-card>

    <a-card title="适用">
      <a-radio-group v-model="pageData.apply">
        <template v-for="apply in listData.applys">
          <a-radio :key="apply.id" :value="Number(apply.name)">
            {{
            apply.label
            }}
          </a-radio>
        </template>
      </a-radio-group>
    </a-card>

    <div class="submut-btn-Group">
      <a-button class="success-button" icon="search" @click="cnki()">查重</a-button>
      <a-button type="primary" icon="form" @click="saveChangeData()">修订</a-button>
      <a-button icon="sync" @click="Refresh">重载</a-button>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  name: 'editPaper',
  components: { VueUeditorWrap },
  data () {
    return {
      bankid: '',
      listData: {
        questionTypes: [], // 题目类型
        diffData: [
          { id: 0, name: 'UNSET', label: '未设置' },
          { id: 1, name: 'VERY_EASY', label: '容易' },
          { id: 2, name: 'EASY', label: '较易' },
          { id: 3, name: 'MODERATE', label: '中等' },
          { id: 4, name: 'HARD', label: '较难' },
          { id: 5, name: 'VERY_HARD', label: '困难' },
        ],
        years: [],
        levels: [
          { id: 1, name: '0', value: 'COMMON', label: '普通' },
          { id: 2, name: '1', value: 'SPECIAL', label: '特制' },
          { id: 3, name: '2', value: 'GOOD', label: '精品' },
        ],
        applys: [
          { id: 1, name: '0', value: 'AFTERCLASS', label: '课后' },
          { id: 2, name: '1', value: 'INCLASS', label: '课中' },
          { id: 3, name: '2', value: 'BEFOREClASS', label: '课前' },
        ],
      },
      // R
      quesid: '',
      pageData: {},
      config1: {
        toolbars: [
          [
            'Undo',
            'Redo',
            'Source',
            'preview', //'FullScreen',  'emotion', 'forecolor','preview',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'indent',
            'Bold',
            'italic',
            'underline',
            'fontdotted',
            'strikethrough',
            'superscript',
            'subscript',
            'removeformat',
            '|',
            'snapscreen',
            //'wordimage',
            'spechars',
            'simpleupload',
            'insertimage',
            'matheq', // 'pasteplain','mathcas',
            //'|',
            'quesboundary',
            'quesindex1',
            //'|',
            //'quesoption1',
            //'quesoption2', 'quesoption3', 'quesoptionformat',
            'quesblank1',
            'quesblank2',
            'quesblank3',
            'quesblank7',
            'quesblank8',
            'quesblank9',
            'quesblank10',
            'quesblank11',
            'quesblank12',
            'quesindex2',
            /*'quesblank11',*/ 'quesoptionformat',
            'fullscreen',
          ],
        ],
        // 上传文件接口
        // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
        // serverUrl: 'https://localhost:8090/ueditor/ueditorConfig',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/ueditor/',
        SERVER_ROOT_URL: process.env.VUE_APP_BASE_API + "v1/learnonly/",
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 工具栏是否可以浮动
        // autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 关闭自动保存
        enableAutoSave: true,
      },
      config2: {
        toolbars: [
          [
            'Undo',
            'Redo',
            'Source', //'FullScreen',  'emotion', 'forecolor','preview',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'indent',
            'Bold',
            'italic',
            'underline',
            'fontdotted',
            'strikethrough',
            'superscript',
            'subscript',
            'removeformat',
            '|',
            //'wordimage',
            'spechars',
            'simpleupload',
            'insertimage',
            'matheq', // 'pasteplain','mathcas',
            'quesindex1',
            'answerblock',
            //'|',
            //'quesindex1', 'quesindex2',
            //'|',
            //'quesoption1',
            //'quesoption2', 'quesoption3', 'quesoptionformat',
            'fullscreen',
          ],
        ],
        UEDITOR_HOME_URL: '/ueditor/',
        SERVER_ROOT_URL: process.env.VUE_APP_BASE_API + "v1/learnonly/",
        toolbarsAlign: 'left',
        wordCount: false, //关闭字数统计
        elementPathEnabled: false, //关闭elementPath
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: '100%',
      },
      config3: {
        toolbars: [
          [
            'Undo',
            'Redo',
            'Source', //'FullScreen',  'emotion', 'forecolor','preview',
            '|',
            'justifyleft',
            'justifycenter',
            'justifyright',
            'indent',
            'Bold',
            'italic',
            'underline',
            'fontdotted',
            'strikethrough',
            'superscript',
            'subscript',
            'removeformat',
            '|',
            //'wordimage',
            'spechars',
            'simpleupload',
            'insertimage',
            'matheq', // 'pasteplain','mathcas',
            'quesindex1',
            'recorder', //,'fontborder'
            //'|',
            //'quesindex1', 'quesindex2',
            //'|',
            //'quesoption1',
            //'quesoption2', 'quesoption3', 'quesoptionformat',

            'fullscreen',
          ],
        ],
        UEDITOR_HOME_URL: '/ueditor/',
        SERVER_ROOT_URL: process.env.VUE_APP_BASE_API + "v1/learnonly/",
        toolbarsAlign: 'left',
        wordCount: false, //关闭字数统计
        elementPathEnabled: false, //关闭elementPath
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: '100%',
      },
      // 知识点
      tags: [],
      inputVisible: false,
      inputValue: '',
    }
  },
  methods: {
    // 获取数据
    getList () {
      this.$http
        .get('v1/learnonly/upload/edit/qeditor/' + this.quesid)
        .then((response) => {
          if (response) {
            console.log(response)
            this.pageData = response.data
            this.analysisData(response.data)
            this.analysisList(response.data)
          }
        })
    },
    // 解析页面数据
    analysisData (data) {
      this.pageData = {
        quesid: this.quesid,
        bankid: data.rawQuestion.bankId, // 学科
        typeid: data.rawQuestion.typeId, // 题目类型
        diff: '', // 难易程度
        year: data.rawQuestion.year, // 年份
        stem: data.stem, // 题目
        answer: data.answer, // 答案
        explanation: data.explanation, // 解析
        catalogvals: '',
        tagtaxonomies: '',
        knowledgepoints: data.rawQuestion.knowledgePoints.split(','), // 知识点
        source: data.rawQuestion.source, // 来源
        level: data.rawQuestion.levelCode, // 等级
        apply: data.rawQuestion.applyCode, // 适用
        mediaName: data.mediaName,// 听力媒体文件名
        mediaData: data.mediaData, // 听力媒体文件地址
      }
      this.tags = this.pageData.knowledgepoints
    },
    // 解析页面数组
    analysisList (data) {
      var yearsData = []
      data.years.forEach((i, ikey) => {
        yearsData.push({ id: ikey, name: i + '年', value: i })
      })
      this.listData.years = yearsData
      this.listData.questionTypes = data.questionTypes
      this.listData.questionTypes.unshift({id:0,name:'未知'})
      this.listData.diffData.forEach((d) => {
        if (d.name == data.rawQuestion.experiencedDifficulty) {
          this.pageData.diff = d.id
        }
      })
    },
    // 修订
    saveChangeData () {
      this.pageData.knowledgepoints = this.tags.join(',')
      var data = this.pageData
      data.level = data.level.toString()
      data.apply = data.apply.toString()
      this.$http
        .post('v1/learnonly/upload/upload2submit', data)
        .then((response) => {
          if (response.data.result == true) {
            this.$message.success('修订成功！')
          } else if (response.data.state == 0) {
            this.$message.warning('修订失败！')
          } else if (response.data.result == false) {
            this.$message.warning(response.data.error)
          }
          this.getList()
        })
    },
    // 查重
    cnki () {
      var cnkiPara = new Object()
      cnkiPara = {
        stem: this.pageData.stem,
        quesid: this.pageData.quesid,
        bankid: this.bankid,
      }
      cnkiPara = Object.assign({}, cnkiPara)
      this.$http.post('/search/ajax/duplicate', cnkiPara).then(() => { })
    },

    // 重载
    Refresh () {
      this.getList()
    },
    // tags
    handleClose (removedTag) {
      const tags = this.tags.filter((tag) => tag !== removedTag)
      this.tags = tags
    },

    showInput () {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },

    handleInputChange (e) {
      this.inputValue = e.target.value
    },

    handleInputConfirm () {
      const inputValue = this.inputValue
      let tags = this.tags
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
      }
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      })
    },
    ready (editorInstance) {
      // console.log(`编辑器实例${editorInstance.key}: `, editorInstance)
    },
  },
  created () {
    if (this.$route.path === '/assistant/editPaper' && this.$route.query.id) {
      this.quesid = this.$route.query.id
      this.bankid = this.$route.query.bankId
      this.getList()
    }
  },
  updated () {

    //剔除ueditor中word粘贴时附带产生的space.gif等占位图片
    var ueditorImg = /<img[^<]*?ueditor\/themes\/default\/images\/[^>]*?>/ig
    this.pageData.stem = this.pageData.stem.replace(ueditorImg, "")
    this.pageData.answer = this.pageData.answer.replace(ueditorImg, "")
    this.pageData.explanation = this.pageData.explanation.replace(ueditorImg, "")

    //剔除svg代码
    this.pageData.stem = this.pageData.stem.replace(/<svg[^>]*?>.*?<\/svg>/ig, "")
    this.pageData.answer = this.pageData.answer.replace(/<svg[^>]*?>.*?<\/svg>/ig, "")
    this.pageData.explanation = this.pageData.explanation.replace(/<svg[^>]*?>.*?<\/svg>/ig, "")

    this.pageData.stem = this.pageData.stem.replace(
      /<br[^>]*?>(< img class="quesindex1_label"[^>]*?>)/gi,
      '</p ><p>$1'
    )
    this.pageData.answer = this.pageData.answer.replace(
      /<br[^>]*?>(< img class="quesindex1_label"[^>]*?>)/gi,
      '</p ><p>$1'
    )
    this.pageData.explanation = this.pageData.explanation.replace(
      /<br[^>]*?>(< img class="quesindex1_label"[^>]*?>)/gi,
      '</p ><p>$1'
    )
    // 针对没有加上答案块则自动按段落匹配加上
    if (
      $(this.pageData.stem).find(
        '.quesblank1,.quesblank2,.quesblank3,.quesblank4,.quesblank5,.quesblank6,.quesblank7,.quesblank8,.quesblank9,.quesblank10,.queblank11,.quesblank12'
      ).length > 0 &&
      $(this.pageData.answer).find('span.answerblock').length == 0
    ) {
      this.pageData.answer = this.pageData.answer.replace(
        /<p[^>]*?>([\s\S]*?)<\/p>/gi,
        '<p><span class="answerblock">$1</span></p >'
      )
      // ue.setContent(this.pageData.answer);
    }
  },
}
</script>

<style scoped>
.editPaperPage {
  width: 90%;
  height: 100%;
  padding: 20px auto;
  margin: 0 auto;
}

.editPaperPage .ant-card {
  background: #f1f1f1;
  margin-bottom: 30px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.btn-Group {
  margin-top: 15px;
}

.submut-btn-Group {
  position: fixed;
  top: 67%;
  right: 50px;
  padding: 3px 2px;
  z-index: 999;
  background: rgba(0, 0, 0, 0.51);
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}

.submut-btn-Group button {
  display: block;
}
</style>
